import { WEBSITE_URL } from "../../../shared/config/constants";

// The area types that can be received from revgeo call
export const REGION_LARGE = ['provincie','gemeente','woonplaats','waterschapsgrens','buurt','appartementsrecht']
export const REGION_SMALL = ['weg','postcode','adres','perceel','hectometerpaal','wijk']

export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_ERROR = 'error';

export const MARKER_ICON_URL = `${WEBSITE_URL}/themes/custom/hvcgroep_theme/assets/icons/marker-icon.svg`;

export const THANKS_PAGE_SUFFIX = '/bedankt';

export const MAXIMUM_FILE_SIZE = 5; // MB

export const TERMS_CONDITIONS_URL = `${WEBSITE_URL}/privacy`;
export const CONTACT_URL = `${WEBSITE_URL}/ons-verhaal/klantenservice#paragraaf--3`;

export const SENTRY_DSN = 'https://99f5fdf0c64c43918f63fbf929ecac51@sentry.uncinc.nl/56';
